import { NavLink } from "react-router-dom";
import {
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CNavLink,
  CNavItem,
} from "@coreui/react-pro";
import { cilMenu } from "@coreui/icons-pro";
import CIcon from "@coreui/icons-react";
import StarterBreadcrumb from "./widgets/StarterBreadcrumb";
import StarterAvatarDropdown from "./widgets/StarterAvatarDropdown";
import StarterThemeSwitcher from "./widgets/StarterThemeSwitcher";
import { StarterRoutePath } from "../../../configs/_starter.route-path";
import { useStarterHeaderController } from "../controllers/useStarterHeaderController";
import { logo as starterLogo } from "../../../../assets/brand/coreui-logo-header";

const StarterHeader = (): JSX.Element => {
  const {
    state: { sidebarShow },
    action: { setSidebarShow },
  } = useStarterHeaderController();

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => setSidebarShow(!sidebarShow)}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none">
          <CIcon icon={starterLogo} height={48} aria-valuetext="Logo" />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <CNavLink to={StarterRoutePath.Dashboard} component={NavLink}>
              Dashboard
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink to="/coreui" component={NavLink}>
              CoreUi
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink to="/other" component={NavLink}>
              Other
            </CNavLink>
          </CNavItem>
        </CHeaderNav>
        <CHeaderNav className="ms-auto me-4">
          <StarterThemeSwitcher />
        </CHeaderNav>
        <CHeaderNav className="ms-2 me-2">
          <StarterAvatarDropdown />
        </CHeaderNav>
      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        <StarterBreadcrumb />
      </CContainer>
    </CHeader>
  );
};

export default StarterHeader;
